import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import "./../App.css"


class Routes extends Component {
    render() {
        if (!this.props.data) return null;
    

       
        return (
    
            <section id="routes">
              <Fade duration={1000}>
                <h2>T R A S Y</h2>
                    <div className="row">
                        <div className="tweleve columns">

                                  
                                <h3>Trasy bardzo łatwe i "plaszczate"</h3>

                                    <h3>3 lipca (czwartek)</h3>

                                    <iframe className="routes-img"
                                        src="https://mapy.com/s/cozageheto" width="500" height="380" frameborder="0">
                                    </iframe>

                                    <a href = "images/03_07_2025_czwartek.gpx" download={"03_07_2025_czwartek.gpx"}>Pobierz trasę w formacie GPX</a>
                                                          
                                    <h3>4 lipca (piątek)</h3>

                                    <iframe className="routes-img"
                                       src="https://mapy.com/s/jubulomozu" width="500" height="380" frameborder="0">
                                    </iframe> 

                                    <a href = "images/04_07_2025_piatek.gpx" download={"04_07_2025_piatek.gpx"}>Pobierz trasę w formacie GPX</a>

                                    <h3>5 lipca (sobota)</h3>

                                    <iframe className="routes-img"
                                     src="https://mapy.com/s/cezoruzelo" width="400" height="380" frameborder="0">
                                    </iframe>

                                    <a href = "images/05_07_2025_sobota.gpx" download={"05_07_2025_sobota.gpx"}>Pobierz trasę w formacie GPX</a>


                </div>
               
          </div>

              </Fade>
    
    
            {/* <Fade left duration={1000} distance="40px">
            
              <div className="row">
              Poniżej znajdują się trasy dojazdowe na zlot z najbliższych stacji kolejowych. <br/> Kliknięcie na "Show on map" przenosi do mapy.cz, gdzie jest możliwość pobrania trasy w GPX
                <div className="twelve columns collapsed">
                <div id="portfolio-wrapper"
                    className="bgrid-thirds s-bgrid-thirds cf">
                 <b>Garbatka</b> <br/>
                  <iframe src="https://en.frame.mapy.cz/s/juzonapeho" width="400" height="280" frameborder="0"></iframe>
                  </div>
                  <div>
                  <b>Pionki</b> <br/>
                  <iframe src="https://en.frame.mapy.cz/s/jevasurota" width="400" height="280" frameborder="0"></iframe> 
                  </div>
                  <div>
                  <b>Dęblin</b> <br/>
                  <iframe src="https://en.frame.mapy.cz/s/nemogevure" width="400" height="280" frameborder="0"></iframe>
                  </div>
                  <div>
                  <b>Dobieszyn</b> <br/>
                  <iframe src="https://en.frame.mapy.cz/s/dezolamoca" width="400" height="280" frameborder="0"></iframe>
                  </div>
    
                </div>
              </div>
            </Fade> */}
          </section>
    
        );
      }
    }
    
  
  export default Routes;
  